module.exports = {"serverUrl":"/smsapi/","homepage":"https://sms.siminn.is/","domain:":"sms.siminn.is"};


// WEBPACK FOOTER //
// external "{/"serverUrl/":/"/smsapi//",/"homepage/":/"https:/sms.siminn.is//",/"domain:/":/"sms.siminn.is/"}"